import React from 'react';
import type { TourArea } from '../types/onboarding';
interface TourAreasProps {
  areas: TourArea[];
}
export function TourAreas({
  areas
}: TourAreasProps) {
  return <ul className="grid gap-3 sm:grid-cols-2" data-id="element-165" data-mp="1hngyt9ahmd6k">
      {areas.map(area => {
      const Icon = area.icon;
      return <li key={area.name} className={['rounded-xl border p-4 transition-all duration-200 hover:-translate-y-0.5', area.highlight ? 'border-[#10b981]/40 bg-[#10b981]/[0.08] hover:border-[#10b981]/70' : 'border-white/10 bg-white/[0.05] hover:border-[#10b981]/35'].join(' ')} data-id="element-166" data-mp="18ky4jdkrp8vx">
            <div className="flex items-center gap-2.5" data-id="element-167" data-mp="1rjk5msgaazzu">
              <Icon className={['h-4 w-4 shrink-0', area.highlight ? 'text-[#10b981]' : 'text-white/55'].join(' ')} aria-hidden="true" data-id="element-168" data-mp="1rj1zn43tl7eq" />
              <h3 className="font-mono text-[13.5px] font-semibold tracking-tight text-white" data-id="element-169" data-mp="1wu465fansv9p">
                {area.name}
              </h3>
            </div>
            <p className="mt-2 text-sm leading-relaxed text-white/75" data-id="element-170" data-mp="21s5jrkpbg2ds">{area.description}</p>
          </li>;
    })}
    </ul>;
}